import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import swal from "sweetalert";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Link } from "react-router-dom/cjs/react-router-dom";
import MUIDataTable from "mui-datatables";
import { API_URL } from "../../config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import ReceiptIcon from '@material-ui/icons/Receipt';
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import SettingsBackupRestoreIcon from "@material-ui/icons/SettingsBackupRestore";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useParams } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { pathSpliter, checkAuthBranchWare, sortRecordsNewestFirst } from "../../lib/functions";
import {
  currentRouteSet,
  createdDeliverySet,
  updatedDeliverySet,
  disableRestoreDeliverySet,
} from "../../actions/actions";

const DeliveryInfo = ({
  location,
  currentRouteSet,
  authInfo,
  createdDelivery,
  updatedDelivery,
  deliveryDisableRestore,
  createdDeliverySet,
  updatedDeliverySet,
  disableRestoreDeliverySet,
}) => {
  const classes = useStyles();
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingList, setLoadingList] = useState(false);
  const [deliveryManUpdateIndex, setDeliveryManUpdateIndex] = useState(-1);
  const [delivery_id, setDeliveryId] = useState("0");
  const [deliveryDetail, setDeliveryDetail] = useState([]);
  const [transportMethods, setTransportMethods] = useState([]);
  const [deliveryCode, setDeliveryCode] = useState("");
  const [action, setAction] = useState("create");
  const [selectedDeliveryMan, setSelectedDeliveryMan] = useState(null);
  const [selectedTransportMethod, setSelectedTransportMethod] = useState(null);
  const [tableRefreshKey, setTableRefreshKey] = useState(0);

  const [successMsg, setSuccessMsg] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
    msg: "",
  });

  const { vertical, horizontal, open, msg } = successMsg;
  const handleClose = () => {
    setSuccessMsg({ ...successMsg, open: false });
  };

  const { saleId } = useParams();
  const delivery_code = "D-0" + saleId;

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    getTransportNames();
    getDelivery();
  }, []);

  const getTransportNames = async () => {
    setLoadingList(true);
    try {
      const res = await axios.post(`${API_URL}/api/get-transport-names`, null, {
        headers: { "auth-token": authInfo.token },
      });
      setTransportMethods(res.data.message);
    } catch (error) {
      console.error("Error fetching transport methods:", error);
    } finally {
      setLoadingList(false);
    }
  };

  const getDelivery = async () => {
    setLoadingList(true);
    try {
      const res = await axios.post(`${API_URL}/api/get-delivery`, null, {
        headers: { "auth-token": authInfo.token },
      });
      setDeliveryDetail(sortRecordsNewestFirst(res.data.message || []));
    } catch (error) {
      console.error("Error fetching delivery info:", error);
    } finally {
      setLoadingList(false);
    }
  };

  // Handle socket events
  useEffect(() => {
    if (createdDelivery) {
      if (checkAuthBranchWare(createdDelivery.user_branch_id)) {
        setDeliveryDetail(sortRecordsNewestFirst([createdDelivery.createdRow, ...deliveryDetail]));
        setSuccessMsg({
          ...successMsg,
          msg: createdDelivery.msg,
          open: true,
        });
        resetForm();
      }
    }
  }, [createdDelivery]);

  useEffect(() => {
    if (updatedDelivery) {
      if (checkAuthBranchWare(updatedDelivery.user_branch_id)) {
        const updatedList = [...deliveryDetail];
        updatedList[updatedDelivery.index] = updatedDelivery.updatedRow;
        setDeliveryDetail(updatedList);
        setSuccessMsg({
          ...successMsg,
          msg: updatedDelivery.msg,
          open: true,
        });
        resetForm();
      }
    }
  }, [updatedDelivery]);

  useEffect(() => {
    if (deliveryDisableRestore) {
      if (checkAuthBranchWare(deliveryDisableRestore.user_branch_id)) {
        const updatedList = [...deliveryDetail];
        updatedList[deliveryDisableRestore.index] = deliveryDisableRestore.disableRestoreRow[0];
        setDeliveryDetail(updatedList);
        setSuccessMsg({
          ...successMsg,
          msg: deliveryDisableRestore.msg,
          open: true,
        });
      }
    }
  }, [deliveryDisableRestore]);

  const resetForm = () => {
    setSelectedDeliveryMan(null);
    setSelectedTransportMethod(null);
    setAction("create");
    setDeliveryId("0");
    setDeliveryManUpdateIndex(-1);
  };

  const saveFormAction = async () => {
    if (!selectedDeliveryMan || !selectedTransportMethod) {
      swal({
        title: "Please select delivery man and transport method",
        icon: "warning",
      });
      return;
    }

    const payLoad = {
      delivery_code: delivery_code,
      delivery_man_name: selectedDeliveryMan.delivery_name || selectedDeliveryMan.delivery_man_name,
      delivery_man_mobile_no: selectedDeliveryMan.delivery_mobile || selectedDeliveryMan.delivery_man_mobile_no,
      transport_method: selectedTransportMethod.transport_name,
      action: action,
      delivery_id: delivery_id,
      deliveryManUpdateIndex: deliveryManUpdateIndex,
    };

    setLoadingSave(true);
    try {
      const res = await axios.post(`${API_URL}/api/delivery-info`, payLoad, {
        headers: { "auth-token": authInfo.token },
      });

      if (res.data.error) {
        swal({
          title: res.data.message,
          icon: "warning",
        });
        return;
      }
      await getDelivery();
      setTableRefreshKey((prev) => prev + 1);
      resetForm();
    } catch (error) {
      console.error("Error saving delivery info:", error);
      swal({
        title: "An error occurred while saving",
        icon: "error",
      });
    } finally {
      setLoadingSave(false);
    }
  };

  const handleEdit = (rowData, rowIndex) => {
    const delivery = deliveryDetail[rowIndex];
    setSelectedDeliveryMan({
      delivery_name: delivery.delivery_name,
      delivery_mobile: delivery.delivery_mobile,
    });
    setSelectedTransportMethod({
      transport_name: delivery.transport_method,
    });
    setAction("update");
    setDeliveryId(delivery.delivery_id);
    setDeliveryManUpdateIndex(rowIndex);
  };

  const handleDisableRestore = async (deliveryId, action, index) => {
    if (action === "disable") {
      const willContinue = await swal({
        title: "Are you sure?",
        text: "Do you want to delete this delivery info?",
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      });
      if (!willContinue) return;
    }

    try {
      const res = await axios.post(
        `${API_URL}/api/delivery-info`,
        { delivery_id: deliveryId, action: action, index: index },
        { headers: { "auth-token": authInfo.token } }
      );
      if (res?.data?.error) {
        swal({ title: res.data.message || "Failed to update delivery info", icon: "warning" });
        return false;
      }
      await getDelivery();
      setTableRefreshKey((prev) => prev + 1);
    } catch (error) {
      console.error("Error updating delivery status:", error);
      swal({
        title: "An error occurred",
        icon: "error",
      });
    }
  };



  const ActionOptions = (props) => {

    let delivery_id = parseInt(props.rowData[3].replace("D-0", ""))

    return (
      <div style={{ textAlign: "right" }}>
        {authInfo.role !== "user" && (

          <>
            <Link to={{ pathname: `/sales/sales-vat-invoice/${delivery_id}` }}>
              <ReceiptIcon

                style={{
                  cursor: "pointer",
                  fontSize: "28px",
                  color: "rgb(15, 126, 119)",
                }}

              />

            </Link>

            <EditIcon
              style={{
                cursor: "pointer",
                fontSize: "28px",
                color: "rgb(15, 126, 119)",
              }}
              onClick={() => handleEdit(props.rowData, props.rowIndex)}
            />
            {props.rowData[1] === "active" ? (
              <DeleteIcon
                style={{
                  cursor: "pointer",
                  color: "#ff0202",
                  fontSize: "28px",
                }}
                onClick={() =>
                  handleDisableRestore(props.rowData[0], "disable", props.rowIndex)
                }
              />
            ) : (
              <SettingsBackupRestoreIcon
                style={{
                  cursor: "pointer",
                  color: "rgb(60, 178, 194)",
                  fontSize: "28px",
                }}
                onClick={() =>
                  handleDisableRestore(props.rowData[0], "restore", props.rowIndex)
                }
              />
            )}
          </>
        )}
      </div>
    );
  };

  const columns = [
    { name: "delivery_id", options: { display: "excluded" } },
    { name: "delivery_status", options: { display: "excluded" } },
    {
      name: "SL",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return <p>{tableMeta.rowIndex + 1}</p>;
        },
      },
    },
    {
      name: "delivery_code",
      label: "#Code",
      options: { filter: true, sort: true },
    },
    {
      name: "delivery_name",
      label: "Delivery Person",
      options: { filter: true, sort: true },
    },
    {
      name: "delivery_mobile",
      label: "Mobile no",
      options: { filter: true, sort: true },
    },
    {
      name: "transport_method",
      label: "Transport",
      options: { filter: true, sort: true },
    },
    {
      name: "actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return (
            <ActionOptions
              rowData={tableMeta.rowData}
              rowIndex={tableMeta.rowIndex}
            />
          );
        },
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
  };

  return (
    <div className={classes.root}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          {msg}
        </Alert>
      </Snackbar>

      <Paper className={classes.paper} style={{ marginTop: "-15px" }}>
        <h2 className={classes.pageEntryLabel}>Delivery Information</h2>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              disabled
              value={delivery_code}
              label="Delivery Code"
              variant="outlined"
              size="small"
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <Autocomplete
              options={deliveryDetail}
              getOptionLabel={(option) => option.delivery_name}
              value={selectedDeliveryMan}
              onChange={(e, newValue) => setSelectedDeliveryMan(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose a delivery man"
                  variant="outlined"
                  size="small"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              disabled
              value={selectedDeliveryMan?.delivery_mobile || ""}
              label="Mobile Number"
              variant="outlined"
              size="small"
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <Autocomplete
              options={transportMethods}
              getOptionLabel={(option) => option.transport_name}
              value={selectedTransportMethod}
              onChange={(e, newValue) => setSelectedTransportMethod(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose transport method"
                  variant="outlined"
                  size="small"
                />
              )}
            />
          </Grid>
        </Grid>

        <Grid container className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<SaveIcon />}
            disabled={loadingSave}
            onClick={saveFormAction}
          >
            {loadingSave ? <CircularProgress size={24} /> : "Save"}
          </Button>
        </Grid>
      </Paper>

      {loadingList ? (
        <><h3>Loading ...</h3></>
      ) : (
        <Paper className={classes.paper} style={{ marginTop: "20px" }}>
          <MUIDataTable
            key={tableRefreshKey}
            title={"Delivery Information List"}
            data={deliveryDetail}
            columns={columns}
            options={options}
          />
        </Paper>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  pageEntryLabel: {
    color: "#7754cc",
    marginBottom: theme.spacing(2),
    textAlign: "left",
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
  },
}));

const mapStateToProps = (state) => ({
  currentRoute: state.currentRouteReducer,
  authInfo: state.authInfoReducer,
  createdDelivery: state.createdDeliveryReducer,
  updatedDelivery: state.updatedDeliveryReducer,
  deliveryDisableRestore: state.deliveryDisableRestoreReducer,
});

export default connect(mapStateToProps, {
  currentRouteSet,
  createdDeliverySet,
  updatedDeliverySet,
  disableRestoreDeliverySet,
})(DeliveryInfo);
